import { useCallback } from "react";
import moment from "moment";
import { useFetcher } from "../useQuery";

type QueryParams = {
  key: string;
  timestamp: string;
};

const useFetchByTradeDetailsData = () => {
  const fetcher = useFetcher();

  return useCallback(
    async ({ key, timestamp }: QueryParams) => {
      const m = moment(timestamp).format("YYYY-MM-DD");
      if (fetcher) {
        const body = await fetcher(`/v2/events`, {
          key: key,
          timestamp: `on:${m}`,
        });
        return body;
      }
    },
    [fetcher]
  );
};

export default useFetchByTradeDetailsData;
